import { useEffect, useState } from "react";
import { Files } from "@/app/vars/Files";

type Props = {
  picture?: string;
  alt?: string;
  className?: string;
  displayLetter?: string;
};

export default function UserPicture(props: Props) {
  const { picture, alt, className, displayLetter } = props;

  const [profilePicture, setProfilePicture] = useState<null | string>();

  useEffect(() => {
    getPicture(picture).then(() => {
      // Nothing to do.
    });
  }, [picture, getPicture]);

  async function getPicture(picture?: string): Promise<void> {
    let p = picture!;

    if (picture) {
      const response = await fetch(picture);
      if (response.ok) {
        p = response.url;
      } else {
        p = Files.DEFAULT_AVATAR;
      }
    } else if (!picture) {
      p = Files.DEFAULT_AVATAR;
    }

    setProfilePicture(p);
  }

  return (
    <>
      {displayLetter ? (
        <p className={className}>{displayLetter}</p>
      ) : (
        profilePicture && <img src={profilePicture} alt={alt || ""} className={className || ""} />
      )}
    </>
  );
}
